$bog_ui_app_skeleton $mol_page
	title \Skeleton
	body /
		<= Description $mol_view
			sub /
				<= description \Loading placeholder with shimmer animation. Use to indicate content is being loaded.
		<= Section_single $mol_view
			sub /
				<= section_single_title \Single Line
		<= Single $bog_ui_skeleton
		<= Section_card $mol_view
			sub /
				<= section_card_title \Card Placeholder
		<= Card $mol_view
			sub /
				<= Card_avatar $bog_ui_skeleton
				<= Card_title $bog_ui_skeleton
				<= Card_line1 $bog_ui_skeleton
				<= Card_line2 $bog_ui_skeleton
				<= Card_short $bog_ui_skeleton
		<= Section_sizes $mol_view
			sub /
				<= section_sizes_title \Different Sizes
		<= Sizes $mol_view
			sub /
				<= Size_small $bog_ui_skeleton
				<= Size_medium $bog_ui_skeleton
				<= Size_large $bog_ui_skeleton
